import styles from "./TiVoAppsList.scss";

export const TABS_CONFIG = [
  {
    id: "",
    label: "",
    columns: [
      {
        id: "displayName",
        label: "Application label",
        sortBy: "label",
      },
      {
        id: "creationDate",
        label: "Creation date",
        sortBy: "creationDate",
        className: styles.dateCol,
      },
      {
        id: "status",
        label: "Status",
        className: styles.statusCol,
      },
      {
        id: "actions",
        label: "",
        className: styles.actionsCol,
      },
    ],
    dataTestId: "tivo-apps-list",
  },
];

export const TEXTS = {
  HEADER: "Providers & variants list",
  CREATE_BTN: "Create provider",
  DRAFT_LABEL: "Draft",
  EMPTY_LABEL: "-- no label --",
  EMPTY_STATUS: "---",
  SEARCH_BAR_PLACEHOLDER: "Search for application",
};
